const doc = [({"en":({"js":({"admin":({"bundle_photo_product":({"create_card":({"create_bundle_photo_product":"Create photo product in bundle"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;